/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_UpdateProspectCommunicationRequest = {
    channel: prospects_UpdateProspectCommunicationRequest.channel;
    direction: prospects_UpdateProspectCommunicationRequest.direction;
    next_followup_date?: string;
    note?: string;
    occurred_at: string;
    outcome: prospects_UpdateProspectCommunicationRequest.outcome;
};
export namespace prospects_UpdateProspectCommunicationRequest {
    export enum channel {
        PHONE = 'phone',
        EMAIL = 'email',
        WHATSAPP = 'whatsapp',
        SMS = 'sms',
        IN_PERSON = 'in_person',
        WEBSITE = 'website',
    }
    export enum direction {
        OUTBOUND = 'outbound',
        INBOUND = 'inbound',
    }
    export enum outcome {
        INTERESTED = 'interested',
        UNSURE = 'unsure',
        CALLBACK_AGREED = 'callback_agreed',
        TOUR_BOOKED = 'tour_booked',
        NO_INTEREST = 'no_interest',
        NO_ANSWER = 'no_answer',
        OTHER = 'other',
    }
}

